import * as React from "react";
const SvgCheckCircleFilled20 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "currentColor", viewBox: "0 0 20 20", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm11.957-1.043a1 1 0 0 0-1.414-1.414L9 11.086 7.457 9.543a1 1 0 0 0-1.414 1.414l2.25 2.25a1 1 0 0 0 1.414 0l4.25-4.25Z" }));
const ForwardRef = React.forwardRef(SvgCheckCircleFilled20);
export default ForwardRef;
